import moment from "moment";

export const dayMapper: { [key: number]: string } = {
  1: "monday",
  2: "tuesday",
  3: "wednesday",
  4: "thursday",
  5: "friday",
  6: "saturday",
  7: "sunday",
};

export interface INextTraining {
  date: Date;
  time: string;
}

export const getNextTraining = (trainingSetup: any): INextTraining | null => {
  if (!trainingSetup) return null;

  const trainingDays = Object.keys(trainingSetup).filter(
    (key) => key !== "__typename" && key !== "time" && trainingSetup[key]
  );
  if (trainingDays.length === 0) return null;

  const upcomingDates = trainingDays.map((day) =>
    moment()
      .day(day)
      .isBefore(Date.now(), "day")
      ? moment()
          .day(day)
          .add(7, "day")
          .toDate()
      : moment()
          .day(day)
          .toDate()
  );
  upcomingDates.sort((a, b) => (moment(a).isAfter(moment(b)) ? 1 : -1));

  const date = upcomingDates[0];
  const dayKey = dayMapper[moment(date).isoWeekday()];
  return { date, time: trainingSetup[dayKey] };
};
